module.exports = __webpack_public_path__ + "static/media/0029.d802507e.jpg";